import { render, staticRenderFns } from "./CreateInstagramV2Channel.vue?vue&type=template&id=25f60396&scoped=true"
import script from "./CreateInstagramV2Channel.vue?vue&type=script&lang=js"
export * from "./CreateInstagramV2Channel.vue?vue&type=script&lang=js"
import style0 from "./CreateInstagramV2Channel.vue?vue&type=style&index=0&id=25f60396&prod&lang=scss&scoped=true"
import style1 from "./CreateInstagramV2Channel.vue?vue&type=style&index=1&id=25f60396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f60396",
  null
  
)

export default component.exports